module.exports = __webpack_public_path__ + "static/media/was.6eb36262.png";